import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  NumberField,
  TextInput,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const SubscriptionRefundDetailsFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="User ID" source="userId" alwaysOn />
  </FilterComponent>
)

export const SubscriptionRefundDetailList = props => (
  <List
    filters={<SubscriptionRefundDetailsFilter />}
    {...props}
    sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <TextField source="id" />
      <TextField source="refundId" />
      <TextField source="subscriptionId" />
      <TextField source="userId" />
      <NumberField source="totalCreditsReceived" />
      <NumberField source="totalCreditsUsed" />
      <NumberField source="allowedCredits" />
      <NumberField source="overUsedCredits" />
      <NumberField source="publisherCommissionDeducted" />
      <DateField source="createdAt" />
      <ShowButton />
    </Datagrid>
  </List>
)

export default SubscriptionRefundDetailList
